import { FormattedMessage, useIntl } from 'react-intl';

import { PeriodUnit, type TermedLevel } from '../../common/termedLevel/types';
import { DATE_FORMAT } from '../../common/utils/dateUtil';
import { formatDurationUnit } from '../../common/utils/formatDurationUnit';

export function ContractDuration(props: { contract: TermedLevel }) {
    const intl = useIntl();
    const useSingularDayUnit = props.contract.periodUnit === PeriodUnit.DAY && props.contract.periodLength === 1;
    return (
        <>
            <div>
                {props.contract.periodLength !== undefined && props.contract.periodUnit !== undefined ? (
                    <>
                        {props.contract.periodLength}{' '}
                        {useSingularDayUnit ? (
                            <FormattedMessage id={'intl-msg:marketplace.durationUnit.day'} />
                        ) : (
                            formatDurationUnit(props.contract.periodUnit, intl)
                        )}
                    </>
                ) : (
                    '--'
                )}
            </div>
            {props.contract.startsAt && props.contract.endsAt && (
                <div className='text-color-gray'>
                    {intl.formatDate(props.contract.startsAt, DATE_FORMAT)} -{' '}
                    {intl.formatDate(props.contract.endsAt, DATE_FORMAT)}
                </div>
            )}
        </>
    );
}
